
import 'bootstrap';
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

import React, { useState, useRef } from "react";
import { UserProfile } from '../user/UserProfile';
import 'maplibre-gl/dist/maplibre-gl.css';
import MapGlOptimized from '../gl-map-optimized';


function MapGlPage() {
    const [isSideBarShown, setSideBarShown] = useState(true);
    const [userProfileModalShow, setUserProfileModalShow] = useState(false);
    const [mobileFiltersOpen, setMobileFiltersOpen] = useState(false);
    const refScrollUp = useRef();

    const handleToggleSidebar = () => {
        setSideBarShown(!isSideBarShown);
    };

    const handleOpenAccountSettings = () => {
        setUserProfileModalShow(true);
    };

    const handleMobileFiltersToggle = () => {
        setMobileFiltersOpen(!mobileFiltersOpen);
        if (refScrollUp.current) {
            refScrollUp.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    return (
        <>
            <div ref={refScrollUp}></div>
            <UserProfile
                show={userProfileModalShow}
                onHide={() => setUserProfileModalShow(false)}
            />
            <div className='wrapper'>
                <MapGlOptimized
                    isSideBarShown={isSideBarShown}
                    setSideBarShown={setSideBarShown}
                    onToggleSidebar={handleToggleSidebar}
                    onOpenAccountSettings={handleOpenAccountSettings}
                    mobileFiltersOpen={mobileFiltersOpen}
                    onMobileFiltersToggle={handleMobileFiltersToggle}
                />
            </div>
        </>
    );
}

export default MapGlPage;
